document.addEventListener('DOMContentLoaded', function() {
    const token = '104898b3301a925bec8908968afe4dac'; // your actual token

    const observer = new MutationObserver(() => {
        const items = document.querySelectorAll('[data-product-handle]');
        if (!items.length) return;

        // Disconnect observer after first match
        observer.disconnect();

        // Collect handles
        const handles = Array.from(items).map(item => item.getAttribute('data-product-handle'));

        // Query Storefront API for SKUs
        fetch('/api/2023-10/graphql.json', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': token
            },
            body: JSON.stringify({
                query: `
                query($handles: [String!]!) {
                  products(handles: $handles) {
                    handle
                    variants(first: 1) {
                      edges {
                        node {
                          sku
                        }
                      }
                    }
                  }
                }`,
                variables: { handles }
            })
        })
        .then(res => res.json())
        .then(data => {
            const products = data.data.products || [];
            products.forEach(product => {
                const item = document.querySelector(`[data-product-handle="${product.handle}"]`);
                if (!item) return;

                const variant = product.variants.edges[0]?.node;
                if (!variant) return;

                // Add SKU below title
                let skuElem = item.querySelector('.sku-display');
                if (!skuElem) {
                    skuElem = document.createElement('div');
                    skuElem.className = 'sku-display';
                    skuElem.style.fontSize = '0.8em';
                    skuElem.style.color = '#888';
                    item.appendChild(skuElem);
                }
                skuElem.innerText = `SKU: ${variant.sku}`;
            });
        })
        .catch(err => {
            console.warn('SKU fetch failed:', err);
        });
    });

    // Start observing the document for changes to predictive search
    observer.observe(document.body, { childList: true, subtree: true });
});
